import React from 'react';

function UserHomeFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="user-home-layout__footer">
      <div className="user-home-layout__footer-content">
        <div className="user-home-layout__footer-copyright">
          © {currentYear} CerebralMachines.ai. All rights reserved.
        </div>
        <div className="user-home-layout__footer-links">
          <a href="/terms" className="user-home-layout__footer-link">Terms of Use</a>
          <a href="/privacy" className="user-home-layout__footer-link">Privacy Policy</a>
          <a href="/support" className="user-home-layout__footer-link">Support</a>
          <a href="/docs" className="user-home-layout__footer-link">Documentation</a>
        </div>
      </div>
    </footer>
  );
}

export default UserHomeFooter;



